export const dateOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  timezone: 'UTC',
};

export default dateOptions;
